import { render, staticRenderFns } from "./RewardManagement.vue?vue&type=template&id=18d808cc&scoped=true&"
import script from "./RewardManagement.vue?vue&type=script&lang=js&"
export * from "./RewardManagement.vue?vue&type=script&lang=js&"
import style0 from "./RewardManagement.vue?vue&type=style&index=0&id=18d808cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d808cc",
  null
  
)

export default component.exports